module.exports = "<div id=\"dashboard-container\" class=\"container\">\n    <fullscreen class=\"fullscreen-btn\" [select]=\"'dashboard-container'\"></fullscreen>\n    <div class=\"left\">\n        <dashboard></dashboard>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing/views/live.html
 ** module id = 882
 ** module chunks = 0
 **/